import { TaskVar } from './task-var';

/**
 * Create a task global, a store which is initialized once per task,
 * or once globally if async_hooks is not available.
 *
 * This is useful for storing per-user data. If initialized in a
 * server component, it will be initialized within the request task,
 * which is user-specific. If initialized on the client, it will be
 * initialized globally within the tab, which is also specific to a
 * user.
 *
 * You can (and probably will) create task globals at the module level,
 * but don't call them there, as that could lead to the value being
 * shared amongst tasks for all users.
 *
 * @param init - initializes the task-global store.
 * @returns - a function that returns the store for the current task
 */
export function taskGlobal<T>(init: () => T): () => T {
  const storage = new TaskVar<T>();
  return () => {
    if (!storage.getStore()) {
      storage.enterGlobal(init());
    }
    return storage.getStore()!;
  };
}
